import { render, staticRenderFns } from "./InboxTable.vue?vue&type=template&id=ea7764f4"
import script from "./InboxTable.vue?vue&type=script&lang=js"
export * from "./InboxTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports